import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// This validator checks if the email is valid and contains a top-level domain.
export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email) ? null : { email: true };
  };
}
